import * as nuveiApi from "app/api/nuveiApi";
import { defineMessages } from "react-intl";

export class NuveiHelpers {
  // return translations
  static nuveiTranslations() {
    const I18n = defineMessages({
      amount: {
        id: "cashier-amount",
      },
      payout: {
        id: "cashier-payout",
      },
      payment: {
        id: "cashier-payment",
      },
      newPayout: {
        id: "cashier-new-payout",
      },
      newPayment: {
        id: "cashier-new-payment",
      },
      pay: {
        id: "cashier-pay",
      },
    });
    return I18n;
  }

  /**
   * Parses a string representing an amount and returns the corresponding number.
   *
   * @param amount - The string representing the amount to be parsed.
   * @returns The parsed number if the string is a valid number, otherwise null.
   */
  static parseAmountToNumber = (amount: string): number | null => {
    const numericAmount = parseFloat(amount);
    return isNaN(numericAmount) ? null : numericAmount;
  };

  static NuveiSimplyConnectScripts = {
    CHECKOUT:
      "https://cdn.safecharge.com/safecharge_resources/v1/checkout/checkout.js",
    WITHDRAWAL:
      "https://cdn.safecharge.com/safecharge_resources/v1/checkout/withdrawal.js",
  };

  static logOpenOrderSuccessResponseToGraylog = (
    description: string,
    resp: any,
    deposit: boolean = false
  ) => {
    // log response to graylog
    const descriptionString = description;
    const {
      merchantId,
      merchantSiteId,
      paymentAttemptId,
      sessionToken,
      status,
    } = resp;
    const responseString = `MerchantId: ${merchantId}, MerchantSiteId: ${merchantSiteId}, PaymentAttemptId: ${paymentAttemptId}, SessionToken: ${sessionToken}, Status: ${status}, resp: ${resp}`;
    // build a return object of string where all data is concatenated together into a single string
    const logString = `${descriptionString}  ${responseString}`;
    // send log to graylog
    if (deposit) {
      nuveiApi.processDepositError(logString, paymentAttemptId);
    } else {
      nuveiApi.processWithdrawalError(logString, paymentAttemptId);
    }
  };

  static logOpenOrderErrorResponseToGraylog = (
    description: string,
    error: any,
    paymentAttemptId: number,
    deposit: boolean = false
  ) => {
    // log response to graylog
    const errorString = error?.response?.data?.errors[0]?.messages[0]
      ? error.response.data.errors[0].messages[0]
      : error.message;
    // build a return object of string where all data is concatenated together into a single string
    const logString = `${description}  ${errorString}`;
    // send log to graylog
    if (deposit) {
      nuveiApi.processDepositError(logString, paymentAttemptId);
    } else {
      nuveiApi.processWithdrawalError(logString, paymentAttemptId);
    }
  };

  static logWithdrawalResultSuccessResponseToGraylog = (
    description: string,
    resp: any,
    paymentAttemptId: number
  ) => {
    // log response to graylog
    const descriptionString = description;
    const {
      errCode,
      merchantWDRequestId,
      reason,
      result,
      userAccountId,
      userId,
      wdRequestId,
      wdRequestStatus,
      wdRequestsLimitReached,
    } = resp;
    const responseString = `ErrCode: ${errCode}, MerchantWDRequestId: ${merchantWDRequestId}, Reason: ${reason}, Result: ${result}, UserAccountId: ${userAccountId}, UserId: ${userId}, WDRequestId: ${wdRequestId}, WDRequestStatus: ${wdRequestStatus}, WDRequestsLimitReached: ${wdRequestsLimitReached}`;
    // build a return object of string where all data is concatenated together into a single string
    const logString = `${descriptionString}  ${responseString}`;
    // send log to graylog
    nuveiApi.processWithdrawalError(logString, paymentAttemptId);
  };

  static logProcessWithdrawalResultSuccessResponseToGraylog = (
    description: string,
    resp: any,
    paymentAttemptId: number
  ) => {
    // log response to graylog
    const descriptionString = description;
    const {
      merchantId,
      merchantSiteId,
      merchantWDRequestId,
      status,
      version,
      wdOrderId,
      wdOrderStatus,
      wdRequestId,
      wdRequestStatus,
    } = resp;
    const responseString = `MerchantId: ${merchantId}, MerchantSiteId: ${merchantSiteId}, MerchantWDRequestId: ${merchantWDRequestId}, Status: ${status}, Version: ${version}, WDOrderId: ${wdOrderId}, WDOrderStatus: ${wdOrderStatus}, WDRequestId: ${wdRequestId}, WDRequestStatus: ${wdRequestStatus}`;
    // build a return object of string where all data is concatenated together into a single string
    const logString = `${descriptionString}  ${responseString}`;
    // send log to graylog
    nuveiApi.processWithdrawalError(logString, paymentAttemptId);
  };

  static logDepositResultSuccessResponseToGraylog = (
    description: string,
    resp: any,
    paymentAttemptId: number
  ) => {
    // log response to graylog
    const descriptionString = description;
    const {
      bin,
      cancelled,
      cavv,
      ccCardNumber,
      ccExpMonth,
      ccExpYear,
      dsTransID,
      eci,
      errCode,
      errorDescription,
      last4Digits,
      mcc,
      result,
      threeDReason,
      threeDReasonId,
      transactionId,
      transactionStatus,
      transactionType,
      userPaymentOptionId,
      xid,
    } = resp;
    const responseString = `Bin: ${bin}, Cancelled: ${cancelled}, Cavv: ${cavv}, CcCardNumber: ${ccCardNumber}, CcExpMonth: ${ccExpMonth}, CcExpYear: ${ccExpYear}, DsTransID: ${dsTransID}, Eci: ${eci}, ErrCode: ${errCode}, ErrorDescription: ${errorDescription}, Last4Digits: ${last4Digits}, Mcc: ${mcc}, Result: ${result}, ThreeDReason: ${threeDReason}, ThreeDReasonId: ${threeDReasonId}, TransactionId: ${transactionId}, TransactionStatus: ${transactionStatus}, TransactionType: ${transactionType}, UserPaymentOptionId: ${userPaymentOptionId}, Xid: ${xid}`;
    // build a return object of string where all data is concatenated together into a single string
    const logString = `${descriptionString}  ${responseString}`;
    // send log to graylog
    nuveiApi.processDepositError(logString, paymentAttemptId);
  };
}
